import React, { useState, useEffect } from 'react';
import axios from 'axios';
const StandartBelgelerPage = () => {
  const [belgeler,setBelgeler] = useState([]);
  const [seciliDosya,setSeciliDosya] = useState(null);
  const [yukleniyor,setYukleniyor] = useState(false);
  const [sonuc,setSonuc] = useState(null);
  const yukle = () => axios.get('/api/admin/belgeler').then(r=>setBelgeler(r.data)).catch(console.error);
  useEffect(()=>{yukle();},[]);
  const handleYukle = async e => {
    e.preventDefault(); if(!seciliDosya)return; setYukleniyor(true); setSonuc(null);
    const fd=new FormData(); fd.append('belge',seciliDosya);
    try { await axios.post('/api/admin/belgeler',fd,{headers:{'Content-Type':'multipart/form-data'}}); setSonuc({tip:'basari',mesaj:`"${seciliDosya.name}" yüklendi.`}); setSeciliDosya(null); yukle(); }
    catch(err) { setSonuc({tip:'hata',mesaj:err.response?.data?.hata||'Yükleme başarısız.'}); }
    finally { setYukleniyor(false); }
  };
  const handleSil = async ad => {
    if(!window.confirm(`"${ad}" silinsin mi?`))return;
    try{await axios.delete(`/api/admin/belgeler/${encodeURIComponent(ad)}`);yukle();}catch{alert('Silme hatası.');}
  };
  const fmtBoyut = b => b<1024?b+' B':b<1048576?(b/1024).toFixed(1)+' KB':(b/1048576).toFixed(1)+' MB';
  const fmt = t=>t?new Date(t).toLocaleDateString('tr-TR'):'-';
  return (
    <div>
      <div style={{marginBottom:'1.5rem'}}><h2 style={{fontSize:'22px',marginBottom:'4px'}}>Standart Belgeler</h2><p style={{fontSize:'13px',color:'var(--yazi-ikincil)'}}>Her talebe otomatik eklenecek belgeleri yönetin. PDF ve DOCX formatları desteklenir.</p></div>
      {sonuc&&<div className={`alert alert-${sonuc.tip==='basari'?'success':'error'}`}>{sonuc.mesaj}</div>}
      <div className="card" style={{marginBottom:'1.5rem'}}>
        <div className="card-header"><h2>Yeni Belge Yükle</h2><p>Vergi levhası, ticaret sicil gazetesi, faaliyet belgesi vb.</p></div>
        <form onSubmit={handleYukle}>
          <label className="dosya-alan" htmlFor="standart-belge">
            <input id="standart-belge" type="file" accept=".pdf,.docx" onChange={e=>setSeciliDosya(e.target.files[0])}/>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--gri-400)" strokeWidth="1.5" style={{margin:'0 auto 8px'}}><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"/></svg>
            <p>PDF veya DOCX dosyası seçmek için tıklayın</p>
            {seciliDosya&&<div style={{marginTop:'8px',fontSize:'13px',color:'var(--yesil)',fontWeight:'500'}}>✓ {seciliDosya.name}</div>}
          </label>
          <div style={{marginTop:'1rem'}}><button type="submit" className="btn btn-primary" disabled={!seciliDosya||yukleniyor}>{yukleniyor?'Yükleniyor...':'Belgeyi Yükle'}</button></div>
        </form>
      </div>
      <div className="card" style={{padding:0,overflow:'hidden'}}>
        <div style={{padding:'1rem 1.25rem',borderBottom:'1px solid var(--border)'}}><p style={{fontSize:'13px',fontWeight:'600'}}>Kayıtlı Belgeler ({belgeler.length})</p></div>
        {belgeler.length===0?<div style={{padding:'3rem',textAlign:'center',color:'var(--yazi-ikincil)',fontSize:'14px'}}>Henüz standart belge yüklenmemiş.</div>
        :<div className="tablo-wrapper"><table>
          <thead><tr><th>Dosya Adı</th><th>Boyut</th><th>Tarih</th><th>İşlem</th></tr></thead>
          <tbody>{belgeler.map(b=>(
            <tr key={b.ad}>
              <td><div style={{display:'flex',alignItems:'center',gap:'10px'}}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--kirmizi)" strokeWidth="1.5"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                <span style={{fontWeight:'500'}}>{b.ad}</span>
              </div></td>
              <td style={{color:'var(--yazi-ikincil)',fontSize:'13px'}}>{fmtBoyut(b.boyut)}</td>
              <td style={{fontSize:'13px'}}>{fmt(b.tarih)}</td>
              <td><button className="btn btn-danger btn-sm" onClick={()=>handleSil(b.ad)}>Sil</button></td>
            </tr>
          ))}</tbody>
        </table></div>}
      </div>
    </div>
  );
};
export default StandartBelgelerPage;
